var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M6.4,33.3h32.2c0.7,0.1,1.3-0.5,1.4-1.2 c0,0,0,0,0,0V12.9c0-0.4-0.2-0.7-0.5-0.9h-34c-0.3,0.2-0.5,0.5-0.5,1v19.3C5.1,32.9,5.7,33.4,6.4,33.3C6.4,33.4,6.4,33.4,6.4,33.3z  M39.5,12.9v19.3c0,0.1-0.1,0.2-0.2,0.3L27,21.4l12.3-8.9L39.5,12.9z M38.6,12.1h0.3L22.5,23.9L6.1,12.1H38.6z M5.5,12.9l0.2-0.4 l12.2,8.8L5.6,32.3c-0.1-0.1-0.1-0.1-0.1-0.2V12.9z M6,32.8l12.4-11.2l3.9,2.9h0.4l3.9-2.8l12.3,11.2H6.4c-0.3,0-0.8-0.1-0.8-0.4 L6,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M39.3,32.4c0.1-0.1,0.2-0.2,0.2-0.3V12.9 l-0.2-0.4L27,21.4L39.3,32.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "38.9,12.1 38.6,12.1 6.1,12.1  22.5,23.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.9,21.3L5.7,12.4l-0.2,0.4v19.3 c0,0.1,0,0.1,0.1,0.2L17.9,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M38.9,32.8L26.6,21.6l-3.9,2.8h-0.4l-3.9-2.9 L6,32.8l-0.4-0.3c0.1,0.3,0.5,0.4,0.8,0.4H38.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.e72e18bf2e422a4bc71ac5d8d99cb536.svg";
export { ForwardRef as ReactComponent };